import { X } from "lucide-react";
import { Eyebrow } from "./Eyebrow";
import { useModalDismiss } from "../hooks/use-modal";

function PhotoFigure({ photo, index }) {
  return (
    <figure>
      <div className="aspect-[4/3] overflow-hidden border border-white/10 bg-[#222A2B]">
        <img
          src={photo.src}
          alt={photo.caption}
          loading="lazy"
          style={{ animationDelay: `${index * -8}s` }}
          className="kb-photo h-full w-full object-cover grayscale"
        />
      </div>
      <figcaption className="mt-3 text-xs uppercase tracking-[0.22em] text-[#DCD7C9]/70">
        {photo.caption}
      </figcaption>
    </figure>
  );
}

export function PhotoModal({ category, onClose }) {
  useModalDismiss(onClose);

  const single = category.photos.length === 1;

  return (
    <div
      data-testid="photo-modal"
      onClick={onClose}
      className="modal-overlay fixed inset-0 z-[100] flex items-center justify-center bg-[#141414]/85 p-5 backdrop-blur-sm sm:p-8"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="modal-panel relative max-h-[90vh] w-full max-w-[980px] overflow-y-auto bg-[#2C3639] p-6 sm:p-10"
      >
        <div className="flex items-center justify-between">
          <Eyebrow dark>{category.label}</Eyebrow>
          <button
            type="button"
            onClick={onClose}
            data-testid="photo-modal-close"
            aria-label="Close"
            className="text-[#DCD7C9] transition-colors duration-300 hover:text-[#A27B5B]"
          >
            <X className="h-6 w-6" />
          </button>
        </div>
        <div
          className={`mt-9 grid grid-cols-1 gap-6 ${
            single ? "sm:mx-auto sm:max-w-[460px]" : "sm:grid-cols-2"
          }`}
        >
          {category.photos.map((p, i) => (
            <PhotoFigure key={p.caption} photo={p} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
